<template>
    <div class="na-form">
        <div class="left">
            <DxTabPanel>
                <DxItem title="Base Data">
                    <div class="dx-fieldset">
                        <div class="dx-field">
                            <div class="dx-field-label">ID:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='record.TlsId' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Name:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='record.TlsName' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Topic Link Type:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='record.TltName' :readOnly="true" /> 
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Trigger Status Name:</div>
                            <div class="dx-field-value"> 
                                <DxTextBox :value='record.TriggerStatusName' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">1st Workflow Name:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='record.WorName1' :readOnly="true" /> 
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">2nd Workflow Name:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='record.WorName2' :readOnly="true" /> 
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Group:</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="GrpName" :dataSource="groupList" :showClearButton='true' valueExpr="GrpId" v-model:value="record.GrpId">
                                </DxSelectBox>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Show Action Button:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value="record.TlsShowInProfile">
                                </DxCheckBox>
                            </div>
                        </div>                  
                        <div class="dx-field">
                            <div class="dx-field-label">Multiselection:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value="record.TlsMultiSelection">
                                </DxCheckBox>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Action Button Text:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value="record.TlsCreateButtonText">
                                </DxTextBox>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Initial Status of Link:</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="StatusName" :dataSource="linkStatusList" :showClearButton='true' valueExpr="StatusID" v-model:value="record.InitialStatusId">
                                </DxSelectBox>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Owner Topic Type:</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="TtyName" :dataSource="topicTypeList1" :showClearButton='true' valueExpr="TtyId" v-model:value="record.OwnerTtyId">
                                </DxSelectBox>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Assignee Topic Type:</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="TtyName" :dataSource="topicTypeList2" :showClearButton='true' valueExpr="TtyId" v-model:value="record.AssigneeTtyId">
                                </DxSelectBox>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Selection Topic Type:</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="TtyName" :dataSource="selectionTopicTypeList" :showClearButton='true' valueExpr="TtyId" v-model:value="record.SelectionTtyId">
                                </DxSelectBox>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Changed On:</div>
                            <div class="dx-field-value">
                                <DxDateBox :value='record.TlsChangedOn' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Changed By:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='record.TlsChangedBy' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Created On:</div>
                            <div class="dx-field-value">
                                <DxDateBox :value='record.TlsCreatedOn' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Created By:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='record.TlsCreatedBy' :readOnly="true" />
                            </div>
                        </div>
                    </div>
                </DxItem>
            </DxTabPanel>
            <div class="na-buttons-row">
                <div>
                    <DxButton :width="120"
                              text="Update"
                              type="success"
                              styling-mode="contained"
                              @click="onSaveClick($event)" />
                </div>
                <div>
                    <DxButton :width="120"
                              text="Delete"
                              type="danger"
                              styling-mode="contained"
                              @click="onDeleteClick($event)" />
                </div>
                <div>
                    <DxButton :width="120"
                              text="Back"
                              type="back"
                              styling-mode="contained"
                              @click="onCancelClick($event)" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { DxTextBox } from 'devextreme-vue/text-box';
    import { DxButton } from 'devextreme-vue/button';
    import { DxTabPanel, DxItem } from 'devextreme-vue/tab-panel';
    import { DxSelectBox } from 'devextreme-vue/select-box';
    import { DxDateBox } from 'devextreme-vue/date-box';
    import { DxCheckBox } from 'devextreme-vue/check-box';
    import $ from 'jquery';
    import { confirm } from "devextreme/ui/dialog"
    export default {
        name: 'TopicLinkTypeStatusDetail',
        components: {
            DxButton,
            DxTextBox,
            DxDateBox,
            DxTabPanel,
            DxSelectBox,
            DxItem,
            DxCheckBox
        },
        data() {
            return {
            };
        },
        props: {
            tlsId: {
                type: [Number],
                required: true,
                default: 0
            },
        },
        computed: {
            record() {
                return this.$store.state.topicLinkTypeStatusStore.topicLinkTypeStatusDetail
            },
            ttyId1() {
                return this.record ? this.record.TtyId1 : 0;
            },
            ttyId2() {
                return this.record ? this.record.TtyId2 : 0;
            },
            worId1() {
                return this.record ? this.record.WorId1 : 0;
            },
            worId2() {
                return this.record ? this.record.WorId2 : 0;
            },
            linkTypeWorId() {
                return this.record ? this.record.LinkTypeWorId : 0;
            },
            statusList1() {
                return this.statusList.filter(m => m.WorId == this.worId1)
            },
            statusList2() {
                return this.statusList.filter(m => m.WorId == this.worId2)
            },
            linkStatusList() {
                return this.statusList.filter(m => m.WorId == this.record.LinkTypeWorId)
            },
            statusList() {
                return this.$store.state.statusStore.statusListSimple;
            },
            topicTypeList() {
                return this.$store.state.topicTypeStore.ttySimpleList;
            },
            topicTypeList1() {
                return this.topicTypeList.filter(m => m.WorId == this.worId1)
            },
            topicTypeList2() {
                return this.topicTypeList.filter(m => m.WorId == this.worId2)
            },
            selectionTopicTypeList() {
                return this.topicTypeList.filter(m => m.WorId == this.worId1 || m.WorId == this.worId2)
            },
            workflowList() {
                return this.$store.state.workflowStore.workflowList
            },
            groupList() {
                return this.$store.state.groupStore.groupListSimple
            },
        },
        created: function () {
        },
        mounted: function () {
            this.$store.dispatch("getTopicLinkTypeStatusDetail", { tlsId: this.tlsId })
                .then(() => {
                });
            this.$store.dispatch("getTtySimpleList")
            this.$store.dispatch("getWorkflowList")
            this.$store.dispatch("getGroupListSimple")
            this.$store.dispatch("getStatusListSimple", { worId: 0 })
        },
        methods: {
            onCancelClick() {
                $("form").attr("action", window.location.pathname + "?action=cancel").submit();
            },
            onSaveClick() { 
                this.$store.dispatch("saveTopicLinkTypeStatusDetail", this.record)
            },
            onDeleteClick() {
                let result = confirm(this.dlg.DeleteConfirmationText, this.dlg.DeleteConfirmationTitle);
                result.then((dialogResult) => {
                    if (dialogResult) {
                        $("form").attr("action", window.location.pathname + "?action=delete&tlsId=" + this.tlsId).submit();
                    }
                });
            },
        }
    }
</script>
<style>
</style>
